import { render, staticRenderFns } from "./DriverStops.vue?vue&type=template&id=e0896520&"
import script from "./DriverStops.vue?vue&type=script&lang=js&"
export * from "./DriverStops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports